export default {
  FETCH_CATEGORY: 'fetchCategory',
  FETCH_ROL: 'fetchRol',
  FETCH_EVENT_BY_ID: 'fetchEventById',
  DELETE_EVENT: 'deleteEvent',
  SAVE_CHANGES: 'saveEventChanges',
  FETCH_EVENTS: 'fetchEvents',
};
